// extracted by css-extract-rspack-plugin
export default {"nonSelectedChoiceChirp":"nonSelectedChoiceChirp-PrzHT_"};